import React from 'react';
import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';

// Data extracted from InfraScripts/ResearchBase/DetailLangTestsBreakdown.txt

const ieltsToClb = [
  { clb: 10, listening: '8.5', reading: '8.0', writing: '7.5', speaking: '7.5' },
  { clb: 9, listening: '8.0', reading: '7.0', writing: '7.0', speaking: '7.0' },
  { clb: 8, listening: '7.5', reading: '6.5', writing: '6.5', speaking: '6.5' },
  { clb: 7, listening: '6.0', reading: '6.0', writing: '6.0', speaking: '6.0' },
  { clb: 6, listening: '5.5', reading: '5.0', writing: '5.5', speaking: '5.5' },
  { clb: 5, listening: '5.0', reading: '4.0', writing: '5.0', speaking: '5.0' },
  { clb: 4, listening: '4.5', reading: '3.5', writing: '4.0', speaking: '4.0' },
];

const celpipToClb = [
  { clb: '10, 11, or 12', score: '10+' },
  { clb: 9, score: 9 },
  { clb: 8, score: 8 },
  { clb: 7, score: 7 },
  { clb: 6, score: 6 },
  { clb: 5, score: 5 },
  { clb: 4, score: 4 },
];

const pteToClb = [
    { clb: 10, listening: '89–90', reading: '88–90', writing: '90', speaking: '89–90' },
    { clb: 9, listening: '82–88', reading: '78–87', writing: '88–89', speaking: '84–88' },
    { clb: 8, listening: '71–81', reading: '69–77', writing: '79–87', speaking: '76–83' },
    { clb: 7, listening: '60–70', reading: '60–68', writing: '69–78', speaking: '68–75' },
    { clb: 6, listening: '50–59', reading: '51–59', writing: '60–68', speaking: '59–67' },
    { clb: 5, listening: '39–49', reading: '42–50', writing: '51–59', speaking: '51–58' },
    { clb: 4, listening: '28–38', reading: '33–41', writing: '41–50', speaking: '42–50' },
];

const tefToNclc = [
    { nclc: '10+', reading: '263-300', writing: '393-450', listening: '316-360', speaking: '393-450' },
    { nclc: 9, reading: '248-262', writing: '371-392', listening: '298-315', speaking: '371-392' },
    { nclc: 8, reading: '233-247', writing: '349-370', listening: '280-297', speaking: '349-370' },
    { nclc: 7, reading: '207-232', writing: '310-348', listening: '249-279', speaking: '310-348' },
    { nclc: 6, reading: '181-206', writing: '271-309', listening: '217-248', speaking: '271-309' },
    { nclc: 5, reading: '151-180', writing: '226-270', listening: '181-216', speaking: '226-270' },
    { nclc: 4, reading: '121-150', writing: '181-225', listening: '145-180', speaking: '181-225' },
];

const tcfToNclc = [
    { nclc: '10+', reading: '549-699', writing: '16-20', listening: '549-699', speaking: '16-20' },
    { nclc: 9, reading: '524-548', writing: '14-15', listening: '523-548', speaking: '14-15' },
    { nclc: 8, reading: '499-523', writing: '12-13', listening: '503-522', speaking: '12-13' },
    { nclc: 7, reading: '453-498', writing: '10-11', listening: '458-502', speaking: '10-11' },
    { nclc: 6, reading: '406-452', writing: '7-9', listening: '398-457', speaking: '7-9' },
    { nclc: 5, reading: '375-405', writing: '6', listening: '369-397', speaking: '6' },
    { nclc: 4, reading: '342-374', writing: '4-5', listening: '331-368', speaking: '4-5' },
];


const LanguageScoresInfo = ({ testType }) => {
  const renderContent = () => {
    switch (testType) {
      case 'ielts':
        return (
          <TableContainer component={Paper}>
            <Typography variant="h6" sx={{ p: 2 }}>IELTS to CLB Conversion</Typography>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>CLB Level</TableCell>
                  <TableCell>Listening</TableCell>
                  <TableCell>Reading</TableCell>
                  <TableCell>Writing</TableCell>
                  <TableCell>Speaking</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {ieltsToClb.map((row) => (
                  <TableRow key={row.clb}>
                    <TableCell>{row.clb}</TableCell>
                    <TableCell>{row.listening}</TableCell>
                    <TableCell>{row.reading}</TableCell>
                    <TableCell>{row.writing}</TableCell>
                    <TableCell>{row.speaking}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        );
      case 'celpip':
        return (
          <TableContainer component={Paper}>
            <Typography variant="h6" sx={{ p: 2 }}>CELPIP to CLB Conversion</Typography>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>CLB Level</TableCell>
                  <TableCell>CELPIP Score (All Abilities)</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {celpipToClb.map((row) => (
                  <TableRow key={row.clb}>
                    <TableCell>{row.clb}</TableCell>
                    <TableCell>{row.score}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        );
    case 'pte':
        return (
          <TableContainer component={Paper}>
            <Typography variant="h6" sx={{ p: 2 }}>PTE Core to CLB Conversion</Typography>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>CLB Level</TableCell>
                  <TableCell>Listening</TableCell>
                  <TableCell>Reading</TableCell>
                  <TableCell>Writing</TableCell>
                  <TableCell>Speaking</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {pteToClb.map((row) => (
                  <TableRow key={row.clb}>
                    <TableCell>{row.clb}</TableCell>
                    <TableCell>{row.listening}</TableCell>
                    <TableCell>{row.reading}</TableCell>
                    <TableCell>{row.writing}</TableCell>
                    <TableCell>{row.speaking}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        );
    case 'tef':
        return (
          <TableContainer component={Paper}>
            <Typography variant="h6" sx={{ p: 2 }}>TEF Canada to NCLC Conversion</Typography>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>NCLC Level</TableCell>
                  <TableCell>Reading</TableCell>
                  <TableCell>Writing</TableCell>
                  <TableCell>Listening</TableCell>
                  <TableCell>Speaking</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {tefToNclc.map((row) => (
                  <TableRow key={row.nclc}>
                    <TableCell>{row.nclc}</TableCell>
                    <TableCell>{row.reading}</TableCell>
                    <TableCell>{row.writing}</TableCell>
                    <TableCell>{row.listening}</TableCell>
                    <TableCell>{row.speaking}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        );
    case 'tcf':
        return (
          <TableContainer component={Paper}>
            <Typography variant="h6" sx={{ p: 2 }}>TCF Canada to NCLC Conversion</Typography>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>NCLC Level</TableCell>
                  <TableCell>Reading</TableCell>
                  <TableCell>Writing</TableCell>
                  <TableCell>Listening</TableCell>
                  <TableCell>Speaking</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {tcfToNclc.map((row) => (
                  <TableRow key={row.nclc}>
                    <TableCell>{row.nclc}</TableCell>
                    <TableCell>{row.reading}</TableCell>
                    <TableCell>{row.writing}</TableCell>
                    <TableCell>{row.listening}</TableCell>
                    <TableCell>{row.speaking}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        );
      default:
        return (
            <Box component={Paper} sx={{ p: 2 }}>
                <Typography variant="h6" gutterBottom>Language Score Information</Typography>
                <Typography>
                    Enter your scores for the selected language test. The system uses these scores to calculate your Canadian Language Benchmark (CLB) level for each of the four abilities: speaking, listening, reading, and writing. Your CLB levels are critical for determining your CRS points.
                </Typography>
            </Box>
        );
    }
  };

  return <Box>{renderContent()}</Box>;
};

export default LanguageScoresInfo;